import { render, staticRenderFns } from "./recordCommentList.vue?vue&type=template&id=819a2434&scoped=true"
import script from "./recordCommentList.vue?vue&type=script&lang=js"
export * from "./recordCommentList.vue?vue&type=script&lang=js"
import style0 from "./recordCommentList.vue?vue&type=style&index=0&id=819a2434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819a2434",
  null
  
)

export default component.exports